import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

function useQRCodeAPI() {
  const { languageRef } = useStorage();

  function loadQRCodeFromRemote(id) {
    const url = `/vbeta2/menu/qrcodes/${id}`;

    return axios({
      url,
      method: 'get',
      params: {
        lang: languageRef.current?.tag,
      },
      headers: {
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  return {
    loadQRCodeFromRemote,
  };
}

export { useQRCodeAPI };
